module.exports = __webpack_public_path__ + "img/inactive-state.61c15c24.svg";